/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import * as actions from 'state/action-types';
import setInProgress from './set-in-progress';

export default () => (dispatch) => {
	return vd
		.importOperation()
		.getInProgress()
		.then((operation) => {
			dispatch({
				type: actions.REQUEST_PROGRESS_OPERATION_SUCESS,
			});
			dispatch(setInProgress(operation));
			return operation;
		})
		.catch((error) => {
			if (error === 'Error: Not Found') {
				return dispatch(setInProgress(null));
			}
			throw error;
		});
};
